export default __webpack_public_path__ + "static/media/technical-ed-gif.d0bda571.gif";